import React from 'react'
import {
  SendOutlined,
  AlertOutlined,
  ClockCircleOutlined,
  CheckOutlined,
  EyeOutlined,
  FlagOutlined,
  PhoneOutlined,
  PushpinOutlined,
  WarningOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'
import type { IconId } from '../config/task-kind-registry'

const MAP: Record<IconId, React.ComponentType<{ style?: React.CSSProperties }>> = {
  send: SendOutlined,
  alert: AlertOutlined,
  clock: ClockCircleOutlined,
  check: CheckOutlined,
  eye: EyeOutlined,
  flag: FlagOutlined,
  phone: PhoneOutlined,
  pushpin: PushpinOutlined,
  warning: WarningOutlined,
  info: InfoCircleOutlined,
}

export const KindIcon: React.FC<{ icon: IconId; color?: string; size?: number }> = ({
  icon,
  color,
  size = 13,
}) => {
  const Cmp = MAP[icon] ?? InfoCircleOutlined
  return <Cmp style={{ color, fontSize: size }} />
}
